
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[slugCoach]/tracks",
      function () {
        return require("private-next-pages/coaches/[slugCoach]/tracks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[slugCoach]/tracks"])
      });
    }
  